<template>
  <modal-layout :is-open="isOpen" @close="closeModal()">
    <div class="Modal_area">
      <div
        class="Modal__cross-box _cross"
        role="button"
        tabindex="0"
        aria-label="クラス詳細モーダルを閉じる"
        @click="closeModal()"
      >
        <span class="Modal__cross" />
      </div>
      <div class="Modal_inner">
        <div v-if="scheduleDetail">
          <div class="Modal_schedule">
            {{ handleDateToDay(scheduleDetail.date) }} {{ scheduleDetail.learning_time }}～
            <div class="Label Label__time Modal__label_time">
              {{ scheduleDetail.time }}分
            </div>
          </div>
          <div class="Modal_schedule_main">
            <div class="Modal_class_badges">
              <div
                class="Modal_class_category_name"
                :style="'background-color: ' + scheduleDetail.master_program_category.c_background_color"
              >
                {{ scheduleDetail.master_program_category.category_name }}
              </div>
            </div>
            <div class="Modal_class_info">
              <div class="Modal_class_name">
                <img
                  class="Modal_class_icon"
                  :src="scheduleDetail.master_program_category.c_icon_url"
                  alt="icon"
                >
                {{ scheduleDetail.title }}
              </div>
              <!-- <div
                :class="`Modal_class_favorite_btn ${isCategotyFavorite ? '_active' : ''}`"
                @click="changeCategoryFavorite(scheduleDetail.class_category)"
              /> -->
            </div>
            <div class="Modal_class_description">
              <!-- eslint-disable vue/no-v-html -->
              <p v-html="scheduleDetail.master_program_category.description" />
              <!-- eslint-enable -->
              <div v-if="scheduleDetail.detail_url" class="Modal_class_detail_url">
                <a class="Modal_class_detail_url_link" :href="scheduleDetail.detail_url" target="_blank">
                  クラス詳細を見る
                </a>
                <img src="/assets/img/icon_arrow_right.png" alt="icon" class="Modal_class_detail_url_icon">
              </div>
            </div>
            <div class="Modal_class_instructor">
              <div class="Modal_class_instructor_head">
                担当インストラクター
              </div>
              <div class="Modal_class_instructor_info">
                <img :src="showAvatar(scheduleDetail.master_instructor)" alt="icon" class="Modal_class_instructor_img">
                <div class="Modal_class_instructor_name">
                  {{ scheduleDetail.master_instructor ? scheduleDetail.master_instructor.name : '' }}
                </div>
                <!-- <div
                  :class="`Modal_class_favorite_btn ${isInstructorFavorite ? '_active' : ''}`"
                  @click="changeInstructorFavorite(scheduleDetail.instructor)"
                /> -->
              </div>
            </div>
          </div>
        </div>
        <div class="Modal_btn_area Modal_btn_area--md Modal_btn_area--mgb">
          <div>
            <label class="Check__box">
              <input
                v-model="scheduleDetail.is_later"
                type="checkbox"
                name="checkbox01"
                @click="changeLater(scheduleDetail.id)"
              >
              <span class="Check__box_inner" />後で見る
            </label>
          </div>
          <div class="Btn Btn--cl02 Btn--md Btn--br4" @click="melonVideo(scheduleDetail.id)">
            動画を見る
          </div>
        </div>
      </div>
    </div>
  </modal-layout>
</template>
<script>
import ModalLayout from '@/views/components/modals/ModalLayout'
import { mapState } from 'vuex'
import melontvService from '@/services/melontvService'
import melontvlaterService from '@/services/melontvlaterService'
import moment from 'moment'
import { convertAvatar } from '@/helpers'

export default {
  name: 'ModalMelonTV',
  components: { ModalLayout },
  data() {
    return {
      isOpen: false,
      data: {},
      scheduleDetail: {
        master_program_category: {
          name: ''
        }
      }
    }
  },
  computed: {
    ...mapState({
      scheduleId: state => state.modal.modalMelonTvId
    })
  },
  watch: {
    scheduleId(value) {
      if (value > 0) {
        melontvService.show(value).then((detail) => {
          this.scheduleDetail = detail.data
          this.isOpen = true
        }).catch(error => {
          console.log(error)
        })
      } else {
        this.isOpen = false
      }
    }
  },
  methods: {
    closeModal() {
      this.$store.commit('modal/setModalMelonTV', 0)
    },
    handleDateToDay(date) {
      return moment(date).locale('ja').format('MMMDo(ddd)')
    },
    async changeLater(id) {
      await melontvlaterService.add(id)
      this.$emit('reloadmelon')
    },
    melonVideo(id) {
      this.$store.commit('modal/setModalMelonTV', 0)
      this.$router.push('/melon-video/' + id)
    },
    showAvatar(instructor) {
      let url = null
      if (instructor) {
        url = instructor.image_url
      }
      return convertAvatar(url)
    }
  }
}
</script>
